import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useInsightsExport = defineStore('insightsExport', () => {
  const exportConfig = ref({
    csvExport: false,
    pngExport: false,
    isReqReport: false,
    pageDownloadId: 'insights',
    // { [widgetId]: labelInModal }
    pngWidgetOptions: {},
    /* [{ label, csvDownloadFunction, waitTime }]
    waitTime is synthetic download time when its non-async download function */
    csvOptions: [],
  });
  const exportInProgress = ref(false);
  const fullReportExportInProgress = ref(false);

  const setExportConfig = (config) => {
    exportConfig.value = { ...exportConfig.value, ...config };
  };

  const resetExportConfig = () => {
    exportConfig.value = {
      csvExport: false,
      pngExport: false,
      isReqReport: false,
      pageDownloadId: 'insights',
      pngWidgetOptions: {},
      csvOptions: [],
    };
  };

  const updateExportInProgress = (isExporting) => {
    exportInProgress.value = isExporting;
  };

  const updateFullReportExportInProgress = (isExporting) => {
    fullReportExportInProgress.value = isExporting;
  };

  return {
    exportConfig,
    exportInProgress,
    fullReportExportInProgress,

    setExportConfig,
    resetExportConfig,
    updateExportInProgress,
    updateFullReportExportInProgress,
  };
});
